// extracted by mini-css-extract-plugin
export default {"groupTitle":"ReportsGroupBody_groupTitle__zSIH0","groupTotal":"ReportsGroupBody_groupTotal__-zNRv","groupBody":"ReportsGroupBody_groupBody__njz9X"};